<template>
    <div class="relative">
        <Handle
            v-for="position in positions"
            :key="position"
            type="target"
            :id="position"
            :position="position"
            class="absolute opacity-0"
            :style="handleStyle(position)"
        />

        <div
            class="w-24 h-24 shadow-lg border-2 hover:border-blue-500 transition-all duration-150 rounded-lg"
            :class="{'border-blue-500': props.isHover, 'border-white': !props.isHover}"
        >
            <svg xmlns="http://www.w3.org/2000/svg" x="20px" y="0px" viewBox="0 0 56 56"><path fill="#FFFFFF" d="M4,0h48c2.2,0,4,1.8,4,4v48c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"></path><g transform="translate(0 -152.787)"><g><path fill="#CFD8DC" d="M12,165.8h27c1.1,0,2,0.9,2,2v2.3c0,1.1-0.9,2-2,2H12c-1.1,0-2-0.9-2-2v-2.3 C10,166.7,10.9,165.8,12,165.8z"></path></g><g><path fill="#90A4AE" d="M12,176.6h27c1.1,0,2,0.9,2,2v2.3c0,1.1-0.9,2-2,2H12c-1.1,0-2-0.9-2-2v-2.3 C10,177.5,10.9,176.6,12,176.6z"></path></g><g><path fill="#CFD8DC" d="M12,187.5h27c1.1,0,2,0.9,2,2v2.3c0,1.1-0.9,2-2,2H12c-1.1,0-2-0.9-2-2v-2.3 C10,188.4,10.9,187.5,12,187.5z"></path></g><g><circle fill="#FFFFFF" cx="40.3" cy="190" r="5.2"></circle><path fill="#78909C" d="M40.3,195.7c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7l0,0 C46,193.1,43.4,195.7,40.3,195.7z M40.3,185.3c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7l0,0 C45,187.4,42.9,185.3,40.3,185.3z"></path></g><g><path fill="#78909C" d="M42.7,187.9v0.6c0,0.1,0,0.1-0.1,0.2l-1.7,2.2h0v2.4c0,0.1,0,0.2-0.1,0.2 c-0.1,0.1-0.3,0.1-0.4,0l-0.6-0.6c-0.1-0.1-0.1-0.2-0.1-0.2v-1.8h0l-1.7-2.2c0-0.1-0.1-0.1-0.1-0.2l0,0v-0.6 c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0h4.2C42.5,187.6,42.7,187.7,42.7,187.9C42.7,187.9,42.7,187.9,42.7,187.9z"></path></g><g><line fill="transparent" x1="20" y1="183" x2="38.6" y2="183"></line></g></g></svg>
        </div>
        <div :title="label" class="absolute w-full flex items-center justify-center">
            {{ props.label }}
        </div>
    </div>

</template>

<script setup>
import { Position } from '@vue-flow/core'
import { Handle } from '@vue-flow/core'
import {defineProps} from 'vue'

const props = defineProps({
    label: String,
    isHover: { type: Boolean, default: false },

})

const positions = [Position.Top, Position.Left, Position.Right, Position.Bottom]

const handleStyle = (position) => {
    const size = 0 // размер хендла
    const offset = -size / 2 // смещение для точного позиционирования

    switch(position) {
        case Position.Top: return { top: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
        case Position.Left: return { left: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Right: return { right: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Bottom: return { bottom: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
    }
}
</script>
